/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseFeatureBlockFragment, FeatureBlockFragment, FullFeatureBlockFragment} from '@amblique/contentful/app/contentful/fragments/feature-block';

/**
 * Get a single FeatureBlock by ID (base - scalars only)
 */
export const getBaseFeatureBlockById = gql`
  ${BaseFeatureBlockFragment}

  query GetBaseFeatureBlockById($id: String!, $locale: String!, $preview: Boolean) {
    featureBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseFeatureBlockFragment
    }
  }
`;

/**
 * Get a single FeatureBlock by ID (standard - 1 level deep)
 */
export const getFeatureBlockById = gql`
  ${FeatureBlockFragment}

  query GetFeatureBlockById($id: String!, $locale: String!, $preview: Boolean) {
    featureBlock(id: $id, locale: $locale, preview: $preview) {
      ...FeatureBlockFragment
    }
  }
`;

/**
 * Get a single FeatureBlock by ID (full - 2 levels deep)
 */
export const getFullFeatureBlockById = gql`
  ${FullFeatureBlockFragment}

  query GetFullFeatureBlockById($id: String!, $locale: String!, $preview: Boolean) {
    featureBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullFeatureBlockFragment
    }
  }
`;

/**
 * Get all FeatureBlock entries with pagination (base - scalars only)
 */
export const getBaseFeatureBlocks = gql`
  ${BaseFeatureBlockFragment}

  query GetBaseFeatureBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeatureBlockOrder]
    $where: FeatureBlockFilter
    $preview: Boolean
  ) {
    featureBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseFeatureBlockFragment
      }
    }
  }
`;

/**
 * Get all FeatureBlock entries with pagination (standard - 1 level deep)
 */
export const getFeatureBlocks = gql`
  ${FeatureBlockFragment}

  query GetFeatureBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeatureBlockOrder]
    $where: FeatureBlockFilter
    $preview: Boolean
  ) {
    featureBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FeatureBlockFragment
      }
    }
  }
`;

/**
 * Get all FeatureBlock entries with pagination (full - 2 levels deep)
 */
export const getFullFeatureBlocks = gql`
  ${FullFeatureBlockFragment}

  query GetFullFeatureBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [FeatureBlockOrder]
    $where: FeatureBlockFilter
    $preview: Boolean
  ) {
    featureBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullFeatureBlockFragment
      }
    }
  }
`;
